<template>
  <div class="cancha-bg min-h-screen">
    <div class="relative">
      <HeroFbochasComponent />
    </div>

    <main class="relative z-10">
      <HomeSectionsFbochasComponent />
    </main>
  </div>
</template>

<script setup>
import HeroFbochasComponent from "@/components/Home/HeroFbochasComponent.vue";
import HomeSectionsFbochasComponent from "@/components/Home/HomeSectionsFbochasComponent.vue";
</script>
